






















































import Vue from 'vue';
import { mapState } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Header from '@/components/Header.vue';

export default Vue.extend({
  components: {
    pxCard,
    Header,
    pxButton,
    ArrowRightIcon,
    SquareEditOutlineIcon,
  },

  data() {
    return {
      courseContext: { id: null },
      currentCoursePage: 0,
      numberOfCoursesToShow: 200,
    };
  },

  computed: {
    ...mapState({
      allClassrooms: (state: any) => state.classrooms.classrooms,
      courses: (state: any) => state.courses.courses,
    }),
    classrooms: function(): any {
      let allClassrooms = this.allClassrooms;
      let courseContext = this.courseContext;
      if (courseContext || courseContext.id === null) {
        return allClassrooms;
      } else {
        return allClassrooms.filter(function(classroom: any) {
          return classroom.course && classroom.course.id === courseContext.id;
        });
      }
    },
  },

  async mounted() {
    this.$store.dispatch('PULL_CLASSROOMS');
    this.$store.dispatch('PULL_COURSES', {
      currentPage: this.currentCoursePage,
      numberOfCoursesToShow: this.numberOfCoursesToShow,
    });
  },

  methods: {
    // removeClassroom: async function(classroomId: number, index: number) {
    //   if (
    //     confirm(
    //       "Tem certeza que deseja deletar essa turma? Ela não poderá ser recuperada!"
    //     )
    //   ) {
    //     let response = await this.$store.dispatch("REMOVE_CLASSROOM", classroomId);
    //     if (response === true) {
    //       this.$store.commit("REMOVE_CLASSROOM", index);
    //     } else {
    //       //TODO analyze the error
    //       console.log(response);
    //       alert("Essa turma não pode ser deletada!");
    //     }
    //   }
    // }
  },
});
